import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import API from './APILink'
import ReactStringReplace from 'react-string-replace'

class AutoComplete extends Component {
    constructor(props) {
        super(props)

        this.componentWillMount = this.componentWillMount.bind(this)
        this.componentDidMount = this.componentDidMount.bind(this)
        this.componentWillUnmount = this.componentWillUnmount.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleClickInside = this.handleClickInside.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.inputRef = React.createRef()
        this.state = {
            userInput: (this.props.keyword) ? this.props.keyword : '',
            userInputFirst: (this.props.keyword) ? this.props.keyword : '',
            filteredSuggestions: [],
            showSuggestions: false,
            ScrollPosition: 0,
            token: 'qwertygf123456',
            required: false
        }
    }

    async handleChange(e) {
        this.setState({
            userInput: e.target.value,
            userInputFirst: e.target.value
        })

        if(""!==e.target.value) {
            await API.get("GetKeywordList.php?token="+this.state.token+"&keyword="+e.target.value)
            .then(response => {
                this.setState({
                    filteredSuggestions:response.data['RECORD'],
                    showSuggestions: true,
                    required: false
                })
            })
            .catch(error => {
                this.setState({
                    filteredSuggestions:[],
                    showSuggestions: false,
                    required: false
                })
            })
        }
    }

    handleClick(e) {
        this.setState({
            userInput: e.target.textContent,
            userInputFirst: e.target.textContent,
            filteredSuggestions: [],
            showSuggestions: false
        })
        this.handleSubmit(e)
    }

    handleKeyDown(e) {
        const {userInputFirst, filteredSuggestions, ScrollPosition} = this.state
        const totalSuggestions = filteredSuggestions.length

        if(totalSuggestions > 0){
            if(e.keyCode === 27) {
                this.setState({
                    showSuggestions: false
                })
            } else if (e.keyCode === 38) {
                if(ScrollPosition === 0) {
                    this.setState({
                        ScrollPosition: totalSuggestions,
                        userInput: filteredSuggestions[totalSuggestions-1],
                        showSuggestions: true
                    })
                } else if(ScrollPosition === 1) {
                    this.setState({
                        ScrollPosition: 0,
                        userInput: userInputFirst,
                        showSuggestions: true
                    })
                } else {
                    this.setState(prevState => ({
                        ScrollPosition: prevState.ScrollPosition - 1,
                        userInput: filteredSuggestions[prevState.ScrollPosition-2],
                        showSuggestions: true
                    }))
                }
            } else if (e.keyCode === 40) {
                if(ScrollPosition === 0) {
                    this.setState({
                        ScrollPosition: 1,
                        userInput: filteredSuggestions[0],
                        showSuggestions: true
                    })
                } else if(ScrollPosition < totalSuggestions){
                    this.setState(prevState => ({
                        ScrollPosition: prevState.ScrollPosition + 1,
                        userInput: filteredSuggestions[prevState.ScrollPosition],
                        showSuggestions: true
                    }))
                } else {
                    this.setState({
                        ScrollPosition: 0,
                        userInput: userInputFirst,
                        showSuggestions: true
                    })
                }
            }
        }
    }

    componentWillMount() {
        document.addEventListener('mousedown',this.handleClickInside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown',this.handleClickInside, false);
    }

    handleClickInside(e) {
        if(this.node.contains(e.target)) {
            this.setState({
                showSuggestions: true
            })
        } else {
            this.setState({
                showSuggestions: false
            })
        }
    }

    handleBlur() {
        this.setState({
            showSuggestions: false,
            required: false
        })
    }

    handleFocus() {
        this.setState({
            showSuggestions: true
        })
    }

    async handleSubmit(e) {
        e.preventDefault()

        if(""!==this.state.userInput) {
            this.setState({
                showSuggestions: false
            })

            // add keyword counter
            await API.post("AddKeyword.php?token="+this.state.token+"&keyword="+this.state.userInput)
           
            this.props.history.push('/search?keyword='+encodeURIComponent(this.state.userInput)+'&sort=terkait')

            if(this.props.refresh){
                return this.props.refresh()
            }
        } else {
            this.setState({
                required: true
            })
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.keyword!==this.state.userInput) {
            this.setState({
                userInput: nextProps.keyword,
                userInputFirst: nextProps.keyword
            })
        }
    }

    componentDidMount() {
        if(this.props.autoFocus) {
            this.inputRef.current.focus()
        }

        if(this.props.keyword) {
            this.setState({
                userInput: this.props.keyword,
                userInputFirst: this.props.keyword
            })
        }
    }
    
    render() {
        const {
            handleChange,
            handleClick,
            handleKeyDown,
            handleSubmit,
            state: {
                userInput,
                filteredSuggestions,
                showSuggestions,
                ScrollPosition,
                required
            }
        } = this;

        const totalSuggestions = filteredSuggestions.length
        
        let suggestionsListComponent;
        if (showSuggestions && userInput) {
            if (totalSuggestions > 0) {
                suggestionsListComponent = (
                    <div className="input-search-autocomplete">
                        {filteredSuggestions.map((value,key) => {
                            return (
                                <span 
                                    key={key}
                                    onMouseDown={handleClick}
                                    className={`${ScrollPosition === key+1 ? 'active' : null}`} 
                                    title={value}>
                                    {ReactStringReplace(value,userInput,(match,i) => (
                                        <b key={i}>{match}</b>
                                    ))}
                                </span>
                            )
                        })}
                    </div>
                )
            }
        }
        return (
            <form className="inline" onSubmit={handleSubmit} ref={node => this.node = node}>
                <input
                    className={`input input-search ${(true===required) ? ' required' : ''}`}
                    type="text"
                    placeholder="Kata Pencarian"
                    value={userInput}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    ref={this.inputRef}
                    autoComplete="off"
                />
                <button type="submit" className="btn btn-search" title="Cari"><FontAwesome name='search'/></button>
                {suggestionsListComponent}
            </form>
        )
    }
}

export default AutoComplete